export const isStatic = process.env.REACT_APP_MODE == 'static'